// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-register-card .select-wrapper:after {\n  right: 20px;\n}\n@media (max-width: 1199px) {\n.p-register-card .select-wrapper:after {\n      right: 10px;\n}\n}\n.p-register-card .btn-colored {\n  text-transform: uppercase;\n}\n", ""]);
// Exports
module.exports = exports;
